import React from "react";

export default function MoneyIcon({ className = "w-16 h-16" }) {
    return (
        <svg
            className={className}
            viewBox="0 0 64 64"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <circle
                cx="32"
                cy="32"
                r="24"
                fill="#7FFF00"
                stroke="#0A1E3E"
                strokeWidth="2"
            />
            <path
                d="M32 18V22M32 42V46"
                stroke="#0A1E3E"
                strokeWidth="2"
                strokeLinecap="round"
            />
            <path
                d="M26 26C26 23 28 22 32 22C36 22 38 23 38 26C38 29 36 30 32 30C28 30 26 31 26 34C26 37 28 38 32 38C36 38 38 37 38 34"
                stroke="#0A1E3E"
                strokeWidth="2.5"
                strokeLinecap="round"
            />
        </svg>
    );
}
